export enum BlockLoginOptions {
    Admin = "admin",
    Front = "front",
    Both = "both"
}
